import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, take, tap } from 'rxjs/operators';
import { QuantityTypeEntity } from '../entities/quantity-type.entity';
import { State } from '../State';
import { QuantityTypeActions } from '../State/actions/accounting.actions';
import { getQuantityTypes } from '../State/selectors/accounting.selector';

@Injectable({
    providedIn: 'root',
})
export class QuantityTypeResolver implements Resolve<QuantityTypeEntity[]> {
    constructor(private store: Store<State>) {}

    resolve() {
        const value$ = this.store.select(getQuantityTypes);
        value$
            .pipe(
                filter(value => !value),
                take(1),
                tap(() => {
                    if (localStorage.getItem('token') != null) {
                        this.store.dispatch(QuantityTypeActions.GetQuantityTypes());
                    }
                }),
            )
            .subscribe();

        return value$.pipe(
            filter(value => !!value),
            take(1),
        );
    }
}
